<template>
  <div class="about-us">
    <app-header></app-header>

    <!-- 轮播图 -->
    <div class="swiper-box">
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(slide, index) in carouselSlides" :key="index">
          <img :src="slide.bgImage" alt="" />
          <div class="slide-content">
            <div class="container">
              <div class="slide-text-content">
                <p class="slide-en-title">{{ slide.enTitle }}</p>
                <h1 class="slide-title">{{ slide.title }}</h1>
              </div>
            </div>
          </div>
        </swiper-slide>

        <!-- 小圆点 -->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <!-- 关于康道道 -->
    <section class="section section01">
      <div class="container">
        <div class="content-box">
          <div class="image-box">
            <img src="@/assets/AboutUs/icon01.png" alt="关于康道道" />
          </div>
          <div class="text-box">
            <h2 class="section-title">关于康道道</h2>
            <div class="content-text">
              <p>
                康道道是专注于医药广阔市场精细化运营与数字化赋能的专业服务平台，致力于通过系统化工具、标准化流程、数据化管理，帮助医药生产企业、品牌方解决渠道散乱、终端不清、团队难管、串货风险高等行业痛点。
              </p>
              <p>我们以"有序营销、价值营销"为核心理念，构建"团队长 - 业务员 - 药店 - 诊所 - 药企管理后台"全链路体系，让每一家药企都能拥有一套属于自己的、可控可管可视的数字化渠道系统。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业文化 -->
    <section class="section section02">
      <div class="container">
        <h2 class="section-title">企业文化</h2>
        <div class="culture-box">
          <div class="culture-item culture-mission">
            <h3 class="item-title">使命</h3>
            <p class="item-desc">让医药渠道更有序、更高效、更合规</p>
          </div>
          <div class="culture-item culture-vision active">
            <h3 class="item-title">愿景</h3>
            <p class="item-desc">成为中国医药广阔市场数字化基础设施</p>
          </div>
          <div class="culture-item culture-values">
            <h3 class="item-title">价值观</h3>
            <p class="item-desc">专业、合规、价值、长期主义</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section class="section section03">
      <div class="container">
        <h2 class="section-title">联系我们</h2>
        <p class="section-subtitle">携手康道道，共建医药新渠道</p>
        <div class="contact-box">
          <div class="contact-item">
            <div class="icon-box icon1"></div>
            <h3 class="contact-title">商务合作</h3>
          </div>
          <div class="contact-item">
            <div class="icon-box icon2"></div>
            <h3 class="contact-title">平台演示申请</h3>
          </div>
          <div class="contact-item">
            <div class="icon-box icon3"></div>
            <h3 class="contact-title">企业定制化方案</h3>
          </div>
          <div class="contact-item">
            <div class="icon-box icon4"></div>
            <h3 class="contact-title">渠道运营咨询</h3>
          </div>
        </div>
      </div>
    </section>

    <app-footer></app-footer>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

export default {
  name: 'AboutUs',
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      swiperOptions: {
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        speed: 600,
        slidesPerView: 1,
        spaceBetween: 0,
        effect: 'slide',
      },
      carouselSlides: [
        {
          bgImage: require('@/assets/AboutUs/banner01.png'),
          enTitle: 'ABOUT US',
          title: '关于我们',
        },
        {
          bgImage: require('@/assets/AboutUs/banner01.png'),
          enTitle: 'ABOUT US',
          title: '关于我们',
        },
        {
          bgImage: require('@/assets/AboutUs/banner01.png'),
          enTitle: 'ABOUT US',
          title: '关于我们',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.about-us {
  padding-top: 80px;
}

.section-title {
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-style: normal;
  font-size: 40px;
  line-height: 53px;
  height: 53px;
  letter-spacing: 0;
  color: #000000;
  text-align: center;
  margin: 0;
}

/* 轮播图样式 */
.swiper-box {
  width: 100%;
  height: 800px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.slide-content {
  position: absolute;
  top: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

:deep(.swiper-container) {
  height: 100%;
}
:deep(.swiper-pagination-bullet) {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ffffff;
  margin: 0 18px !important;
  opacity: 1 !important;
  &.swiper-pagination-bullet-active {
    border-radius: 5px 5px 5px 5px;
    width: 56px;
  }
}
.slide-text-content {
  text-align: center;
  color: #fff;
}

.slide-en-title {
  font-size: 24px;
  color: #fff;
  margin-bottom: 20px;
  letter-spacing: 2px;
  opacity: 0.9;
  text-transform: uppercase;
}

.slide-title {
  font-size: 64px;
  color: #fff;
  font-weight: bold;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

/* 关于康道道 */
.section01 {
  background: linear-gradient(180deg, #1ca19630 0%, #ffffff 100%);
  height: 660px;
  padding-top: 203px;
  padding-bottom: 79px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;

  .section-title {
    height: 40px;
    line-height: 40px;
    padding-bottom: 16px;
    margin-bottom: 21px;
  }

  .content-box {
    display: flex;
    align-items: flex-start;
    gap: 61px;
    max-width: 1200px;
    margin: 0 auto;

    .image-box {
      height: 377px;
      width: 549px;
      border-radius: 30px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .text-box {
      flex: 1;

      .section-title {
        display: inline-block;
        text-align: left;
        padding-bottom: 16px;
        border-bottom: 4px solid #1ca196;
      }

      .content-text {
        p {
          font-family: Microsoft YaHei;
          font-weight: normal;
          font-style: normal;
          margin: 0 0 20px 0;
          text-align: justify;
          color: #000000;
          font-size: 18px;
          line-height: 30px;
          letter-spacing: 0px;
          text-indent: 36px;
        }
      }
    }
  }
}

/* 企业文化 */
.section02 {
  background: #ffffff;
  height: 468px;
  padding-top: 88px;
  padding-bottom: 100px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;

  .section-title {
    margin-bottom: 64px;
  }

  .culture-box {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 18px;
    max-width: 1200px;
    margin: 0 auto;

    .culture-item {
      width: 388px;
      height: 166px;
      background: #f3f3f3;
      border-radius: 30px;
      padding: 40px;
      box-sizing: border-box;
      transition: all 0.3s;

      &.active {
        background: #1ca196;

        .item-title,
        .item-desc {
          color: #ffffff;
        }

        .item-divider {
          background: #ffffff;
        }
      }

      .item-title {
        display: inline-block;
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-style: normal;
        font-size: 24px;
        line-height: 32px;
        letter-spacing: 0;
        color: #000000;
        margin: 0 0 15px 0;
        padding-bottom: 10px;
        border-bottom: 2px solid #d9d9d9;
      }

      .item-divider {
        width: 40px;
        height: 2px;
        background: #1ca196;
        margin-bottom: 20px;
      }

      .item-desc {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-style: normal;
        font-size: 16px;
        line-height: 26px;
        letter-spacing: 0;
        color: #666666;
        margin: 0;
      }
    }
  }
}

/* 联系我们 */
.section03 {
  background: #ffffff;
  height: 689px;
  padding-top: 130px;
  padding-bottom: 155px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;

  .section-title {
    margin-bottom: 12px;
  }

  .section-subtitle {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-style: normal;
    font-size: 34px;
    line-height: 45px;
    letter-spacing: 0;
    color: #000000;
    text-align: center;
    margin: 0 0 100px 0;
  }

  .contact-box {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 80px;
    max-width: 1200px;
    margin: 0 auto;

    .contact-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .icon-box {
        width: 138px;
        height: 138px;
        border-radius: 50%;
        margin-bottom: 28px;
        position: relative;
        overflow: hidden;

        &.icon1 {
          background: linear-gradient(180deg, #c2e5e2 0%, #73b9b3 100%);
          z-index: 2;
          &::before {
            display: block;
            content: '';
            z-index: 1;
            width: 100%;
            height: 100%;
            background: url('@/assets/AboutUs/icon02.png') no-repeat;
            background-position: center center;
            background-size: 50% 50%;
          }
        }
        &.icon2 {
          background: linear-gradient(180deg, #c2e5e2 0%, #73b9b3 100%);
          z-index: 2;
          &::before {
            display: block;
            content: '';
            z-index: 1;
            width: 100%;
            height: 100%;
            background: url('@/assets/AboutUs/icon03.png') no-repeat;
            background-position: center center;
            background-size: 50% 50%;
          }
        }
        &.icon3 {
          background: linear-gradient(180deg, #c2e5e2 0%, #73b9b3 100%);
          z-index: 2;
          &::before {
            display: block;
            content: '';
            z-index: 1;
            width: 100%;
            height: 100%;
            background: url('@/assets/AboutUs/icon04.png') no-repeat;
            background-position: center center;
            background-size: 50% 50%;
          }
        }
        &.icon4 {
          background: linear-gradient(180deg, #c2e5e2 0%, #73b9b3 100%);
          z-index: 2;
          &::before {
            display: block;
            content: '';
            z-index: 1;
            width: 100%;
            height: 100%;
            background: url('@/assets/AboutUs/icon05.png') no-repeat;
            background-position: center center;
            background-size: 50% 50%;
          }
        }
      }

      .contact-title {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-style: normal;
        font-size: 24px;
        line-height: 32px;
        letter-spacing: 0;
        color: #000000;
        margin: 0;
        text-align: center;
      }
    }
  }
}

/* 响应式设计 */
@media (max-width: 1200px) {
}

@media (max-width: 768px) {
}
</style>
